import * as React from 'react';
import { TenderDocumentIntake } from '@/components/tenders/tender-document-intake';

export function AgentTenderPreparation({id,disabled,onBusy,onDirty,onCreated}:{id:string;disabled:boolean;onBusy:(id:string,value:boolean)=>void;onDirty:(id:string,value:boolean)=>void;onCreated:(id:string)=>void}){
  const busy=React.useCallback((value:boolean)=>onBusy('tender:'+id,value),[id,onBusy]);
  const dirty=React.useCallback((value:boolean)=>onDirty(id,value),[id,onDirty]);
  return <TenderDocumentIntake existingId={id} disabled={disabled} onBusy={busy} onDirty={dirty} onCreated={onCreated}/>;
}
